<template>
  <div>
    <transition name="fade-bottom">
      <div v-if="showCookiesBar" class="cookies-bar" :style="{ background: primaryColor }">
        <div class="message">
          <p :style="{ color: secondaryColor }">This website uses cookies and similar technologies to give you a better experience</p>
        </div>

        <div class="buttons">
          <button type="button" data-bs-toggle="modal" data-bs-target="#modal-cookies" :style="{ color: secondaryColor, borderColor: secondaryColor }">CHANGE SETTINGS</button>
          <button type="button" @click="okIConfirmSettings" :style="{ color: secondaryColor, borderColor: secondaryColor }">OK I CONFIRM</button>
        </div>
      </div>
    </transition>

    <div id="modal-cookies" class="modal fade" tabindex="-1" aria-labelledby="modal-cookies-label" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="btn-discard-cookies" data-bs-dismiss="modal" @click="discardSettings()" aria-label="Close">
              <i class="icon-close"></i>
              <span>CANCEL</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="row bg-white pt-lg-8 px-lg-8 pt-5 px-4">
              <div class="col-16">
                <button type="button" class="btn-accept-decline accept" disabled>
                  <div class="btn-accept-decline-icon">
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid meet" viewBox="0 0 200 145.55" width="200" height="145.55">
                      <defs>
                        <path d="M80.25 96.17L24.65 40.56L0 65.22L55.6 120.82L55.53 120.9L80.18 145.55L200 24.65L175.35 0L175.35 0L80.25 96.17Z" id="b1djzotc91"></path>
                      </defs>
                      <g>
                        <g>
                          <g>
                            <use xlink:href="#b1djzotc91" opacity="1" fill="#fff" fill-opacity="1"></use>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </div>

                  <div class="descr">
                    <p class="large fw-semibold">STRICTLY NECESSARY & PERFORMANCE COOKIES</p>
                    <p class="small mt-1">These cookies remember choices you make to improve your experience. This information is not used for advertising on other sites. <b>These cookies are required for website to work properly.</b></p>
                  </div>
                </button>

                <hr class="options-divider">

                <button type="button" class="btn-accept-decline" :class="{ 'accept': optionalCookiesTemp, 'decline': !optionalCookiesTemp }" @click="optionalCookiesTemp = !optionalCookiesTemp">
                  <div class="btn-accept-decline-icon">
                    <svg v-if="optionalCookiesTemp" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid meet" viewBox="0 0 200 145.55" width="200" height="145.55">
                      <defs>
                        <path d="M80.25 96.17L24.65 40.56L0 65.22L55.6 120.82L55.53 120.9L80.18 145.55L200 24.65L175.35 0L175.35 0L80.25 96.17Z" id="b1djzotc91"></path>
                      </defs>
                      <g>
                        <g>
                          <g>
                            <use xlink:href="#b1djzotc91" opacity="1" fill="#fff" fill-opacity="1"></use>
                          </g>
                        </g>
                      </g>
                    </svg>

                    <svg v-else version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid meet" viewBox="0 0 100 100" width="100" height="100">
                      <defs>
                        <path d="M50 39.3L10.65 0L0 10.7L39.3 50L0 89.3L10.65 100L50 60.7L89.3 100L100 89.3L60.65 50L100 10.7L100 10.7L89.3 0L50 39.3Z" id="a6P0pmWeS"></path>
                      </defs>
                      <g>
                        <g>
                          <g>
                            <use xlink:href="#a6P0pmWeS" opacity="1" fill="#fff" fill-opacity="1"></use>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </div>

                  <div class="descr">
                    <p class="large fw-semibold">FUNCTIONAL & TARGETING COOKIES</p>
                    <p class="small mt-1">These cookies share information about your browsing habits with 3rd parties to help make advertising relevant to you and your interests.</p>
                  </div>
                </button>
              </div>

              <div class="col-16 text-center mt-10">
                <button type="button" class="btn-save-cookies" :style="{ background: primaryColor, color: secondaryColor }" data-bs-dismiss="modal" @click="saveAndCloseSettings()">SAVE & CLOSE</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
export default {
  props: {
    primaryColor: {
      type: String,
      required: false,
      default: "#000"
    },
    secondaryColor: {
      type: String,
      required: false,
      default: "#fff"
    }
  },
  data() {
    return {
      showCookiesBar: this.frequencyCookieExpired(),
      optionalCookies: false,
      optionalCookiesTemp: this.optionalCookies
    }
  },
  methods: {
    getFrequencyCookie() {
      let cookie;
      const cookies = `; ${document.cookie}`;
      const parts = cookies.split(`; showCookiesBar=`);

      if (parts.length === 2) {
        cookie = parts.pop().split(';').shift();
      }

      return cookie;
    },
    setFrequencyCookie(value, days = 30) {
      const today = new Date();
      const expireDate = new Date(today.setDate(today.getDate() + days));
      document.cookie = `showCookiesBar=false; expires=${expireDate}`;
    },
    frequencyCookieExpired() {
      return (this.getFrequencyCookie() == null || this.getFrequencyCookie() === true)
    },
    closeCookiesBar() {
      const component = this;
      component.showCookiesBar = false;
      component.setFrequencyCookie(true);
    },
    changeSettings(){

    },
    saveAndCloseSettings() {
      if(typeof this.optionalCookiesTemp !== 'undefined'){
        this.optionalCookies = this.optionalCookiesTemp;
      }else{
        this.optionalCookies = this.optionalCookiesTemp = false;
      }
      this.ajaxSave(this.optionalCookies);
    },
    discardSettings() {
      this.optionalCookiesTemp = this.optionalCookies;
    },
    okIConfirmSettings()
    {
      var sendOption = false;
      if(typeof this.optionalCookiesTemp == 'undefined' || this.optionalCookiesTemp == true){
        sendOption = this.optionalCookiesTemp = true;
      }
      this.ajaxSave(sendOption);
    },
    ajaxSave(selection) {
      
      var _url = "/en/set/cookies?statistics="+selection;
      const component = this;
      return axios.get(_url)
        .then(function (response) {
          console.log('response: ', response);
          component.closeCookiesBar();
          window.location.reload();
        })
        .catch(function (error) {
          console.log('error:', error)
        });
    },
  },
}
</script>

<style lang="scss">
.fade-bottom-enter-active,
.fade-bottom-leave-active {
  transition: opacity 250ms ease-in-out, transform 250ms ease-in-out;
}

.fade-bottom-enter,
.fade-bottom-leave-to {
  opacity: 0;
  transform: translateY(100%);
}

.cookies-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 15px 10px;
  z-index: 1000;
  box-shadow: 0px -10px 20px rgba(#000, 0.3);

  .message {
    p {
      font-size: 0.7rem;
      font-weight: 300;
      text-align: center;
    }
  }

  .buttons {
    margin: 1rem 1rem;
    text-align: center;

    button {
      border-width: 1px;
      border-style: solid;
      margin: 0.2rem 0rem;
      font-size: 0.725rem;
      padding: 10px 15px;
      line-height: 1;
      margin: 0px 0.5rem;
    }
  }
}

.btn-accept-decline {
  position: relative;
  display: flex;
  align-items: center;
  flex-flow: column;

  .btn-accept-decline-icon {
    position: relative;
    width: 57px;
    min-width: 57px;
    height: 57px;
    border-radius: 16px;
    transition: opacity 250ms ease-in-out;

    svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 50%;
      pointer-events: none;
    }
  }

  &.accept {
    .btn-accept-decline-icon {
      background-color: #34a31a;
    }
  }

  &.decline {
    .btn-accept-decline-icon {
      background-color: #da2323;
    }
  }

  &:hover:not([disabled]) {
    .btn-accept-decline-icon {
      opacity: 0.7;
    }
  }

  .descr {
    margin-top: 20px;
    text-align: center;
    line-height: 1.5;
  }

  &:disabled {
    color: #000;
  }
}

.options-divider {
  border-top: 1px solid #000;
  margin: 1.5rem 0px;
}

.btn-discard-cookies {
  text-align: center;

  i {
    color: #fff;

    &::before {
      font-size: 40px;
    }
  }

  span {
    display: block;
    color: #fff;
    letter-spacing: 0.015rem;
    line-height: 1;
  }
}

.btn-save-cookies {
  font-size: 1rem;
  font-weight: 400;
  padding: 20px 40px;
  border-radius: 20px 20px 0px 0px;
  transition: opacity 250ms ease-in-out;

  &:hover {
    background: transparent;
    opacity: 0.6;
  }
}

@media only screen and (min-width: 576px) {
  .btn-accept-decline {
    flex-flow: row;

    .btn-accept-decline-icon {}

    .descr {
      margin-top: 0px;
      margin-left: 20px;
      text-align: left;
    }
  }
}
</style>